import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const UnpublishConfirmModal = ({
  onClose,
  unpublish
}) => {
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "unpublishModal.message"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "unpublishModal.description"
    }),
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "editor.publishing.unpublish"
    }),
    onConfirm: () => {
      unpublish();
      onClose();
    },
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "unpublishModal.cancel"
    }),
    onReject: onClose,
    size: "auto"
  });
};
export default UnpublishConfirmModal;